<template>
    <div class="AppPager" v-if="pager.length">
        <div class="AppPager-scrollTop">
            <span @click="scrollTop()">
                <svg xmlns="http://www.w3.org/2000/svg" overflow="visible" preserveAspectRatio="none" viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
                    <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" vector-effect="non-scaling-stroke"/>
                </svg>
                <span>{{ backToTopLabel }}</span>
            </span>
        </div>
        <div class="AppPager-btnHolder">
            <button v-if="nextPageUrl" @click="loadMore(nextPageUrl)" type="button" class="ButtonBase ButtonBase--sm">
                {{ nextPageLabel }}
            </button>
        </div>

        <div class="AppPager-pager">
            <PagerItem v-for="item in pager" :pagerItem="item"/>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import PagerItem from "@/components/pager/PagerItem.vue";

export default defineComponent({
    name: "Pager",
    components: {PagerItem},
    computed: mapGetters({
        pager: 'getPager',
        nextPageUrl: 'getNextPageUrl',
        nextPageLabel: 'getNextPageLabel',
        backToTopLabel: 'getBackToTopLabel'
    }),
    setup() {
        const scrollTop = (): void => {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }

        return {
            scrollTop
        }
    },
    methods: {
        ...mapActions({
            loadProducts: 'LOAD_PRODUCTS'
        }),
        loadMore(url: string) {
            this.loadProducts({url: url, appendProducts: true})
        }
    }
});
</script>
